import { useMemo, useState } from 'react';
import { Outlet, useMatches } from 'react-router-dom';
import { useSessaoAutenticada } from '../autenticacao/SessaoContexto.js';
import { BarraSuperior } from './BarraSuperior.js';
import { NavegacaoLateral } from './NavegacaoLateral.js';
import {
  ContextoPendenciasDeSaldo,
  useContadorDeDivergenciasDeSaldo,
} from './pendencias-de-saldo.js';
import { useDispositivosBloqueados } from './useDispositivosBloqueados.js';
import { useResumoDeColetas } from './useResumoDeColetas.js';
import './Layout.css';

/** Rotas de detalhe pedem o trilho compacto; elas declaram isso em `handle`. */
type HandleRota = { readonly navCompacta?: boolean };

/**
 * Moldura do painel em duas camadas: o trilho de navegação, na cor do fundo,
 * e a "folha" branca arredondada onde a barra superior e a tela vivem.
 *
 * O trilho recolhe de dois jeitos — pela rota (telas de detalhe pedem largura)
 * ou pela pessoa, no botão da barra superior. A escolha da pessoa vale só
 * para a sessão da aba: preferência de moldura não é dado do armazém.
 */
export function Layout() {
  const { usuario, tenant } = useSessaoAutenticada();
  const trechos = useMatches();
  const dispositivosBloqueados = useDispositivosBloqueados();
  const coletas = useResumoDeColetas();
  const { pendentes: divergenciasDeSaldo, recarregar: recarregarDivergenciasDeSaldo } =
    useContadorDeDivergenciasDeSaldo();
  const pendenciasDeSaldo = useMemo(
    () => ({ pendentes: divergenciasDeSaldo, recarregar: recarregarDivergenciasDeSaldo }),
    [divergenciasDeSaldo, recarregarDivergenciasDeSaldo],
  );
  const [recolhida, definirRecolhida] = useState(false);

  const compactaPelaRota = trechos.some(
    (trecho) => (trecho.handle as HandleRota | undefined)?.navCompacta === true,
  );
  const compacta = compactaPelaRota || recolhida;

  return (
    <div className="moldura">
      <NavegacaoLateral
        usuario={usuario}
        nomeTenant={tenant.nome}
        coletas={coletas}
        dispositivosBloqueados={dispositivosBloqueados}
        divergenciasDeSaldo={divergenciasDeSaldo}
        compacta={compacta}
      />
      <div className="moldura__folha">
        <BarraSuperior
          nomeTenant={tenant.nome}
          navRecolhida={compacta}
          aoAlternarNav={() => {
            definirRecolhida((atual) => !atual);
          }}
        />
        <main className="moldura__area">
          {/* A tela das divergências de saldo recarrega o selo depois de decidir. */}
          <ContextoPendenciasDeSaldo.Provider value={pendenciasDeSaldo}>
            <Outlet />
          </ContextoPendenciasDeSaldo.Provider>
        </main>
      </div>
    </div>
  );
}
